const Form074TC = {
    stepName: {
        importantNotes: "重要事項",
        selectSchool: "選擇學校類別",
        basicInfo: "基本資料",
        confirmation: "確認頁面",
    },
    label: {
        noteHeader: {
            header1: "教育局通告第6/2010號",
            header2:
                "資助學校人員(以行政津貼／修訂行政津貼聘用者)的公積金／強制性公積金僱主供款津貼發放及會計安排",
            header3: "[注意：本通告應交：",
            header4: "(a) 各資助學校校監及校長 — 備辦；以及",
            header5: "(b) 各組主管 — 備考。]",
        },
        noteTitle: {
            title1: "摘要",
            title2: "背景",
            title3: "詳情",
            title4: "查詢",
        },
        noteList: {
            refNo: "檔號： FIN(RS)/F&A/65/63",
            date: "二零一零年七月六日",
            note1: "本通告旨在闡述資助學校人員(以行政津貼／修訂行政津貼聘用者)的公積金／強制性公積金(強積金)僱主供款津貼發放及會計安排。本通告應與現行有關資助學校人員退休福利撥款安排的教育局通告一併閱讀。",
            note2: "資助學校獲發行政津貼／修訂行政津貼，目的是向以這些津貼聘用的人員支付薪金。此外，資助學校亦另獲津貼，用作支付上述人員的公積金／強積金僱主供款實際開支。",
            note3: "由2010/11學年起，公積金／強積金僱主供款津貼發放程序會精簡，以減省資助學校的行政工作。",
            note4: "修訂的發放及會計安排如下：",
            note5: "學校應在每年八月十五日之前，就所有以行政津貼／修訂行政津貼聘用的人員，向教育局經常津貼組提交<u>下學年</u>公積金／強積金僱主供款暫定全年數額申領表(載於附件1)。有關表格可於教育局網頁下載(學校行政及管理＞行政規則＞資助則例＞與中、小、特殊學校資助則例相關的指引和表格)；",
            note6: "在填寫上文(a)項的申領表時，學校應就其所知，提供下學年公積金／強積金僱主供款的最新預算，並簽署證明所提供的資料正確無誤及符合有關通告的規定。學校<u>無須</u>向經常津貼組提交薪金及公積金／強積金供款的支付證明文件，但文件應予保留；",
            note7: "按(a)項的暫定申領額，學校會在同一時間獲發行政津貼／修訂行政津貼及公積金／強積金僱主供款津貼，即設有法團校董會的學校分四期在九月、十一月、二月和五月獲發津貼，而未設有法團校董會的學校則由九月份起每月獲發津貼；",
            note8: "學校應繼續按現行通函所要求，在提交經審核的帳目內加入附表，詳述以行政津貼／修訂行政津貼聘用者的資料，以及與其相關的公積金／強積金供款，以便提交教育局學校核數組；以及",
            note9: "學校獲發的津貼如有盈餘，須退還教育局；如有不足之數，則在學校核數組查閱經審核的帳目後獲得發還。",
            note10: "如對本通告有任何查詢，請與經常津貼組聯絡：",
            note11: "小學",
            note12: "2892 6232",
            note13: "中學",
            note14: "2892 6233",
            note15: "特殊學校",
            note16: "2892 6234",
            note17: "教育局常任秘書長",
            note18: "曾周碧英代行",
            note19: "二零一零年七月六日",
        },
        noteNumber: {
            number2: "2.",
            number3: "3.",
            number4: "4.",
            number5: "5.",
            numbera: "(a)",
            numberb: "(b)",
            numberc: "(c)",
            numberd: "(d)",
            numbere: "(e)",
            numbera1: "a)",
            numberb1: "b)",
        },
        certifyList: {
            certify1: "茲證明以行政津貼／修訂行政津貼支薪的人員會——",
            certify2:
                "在下學年獲得的薪金中扣除以下僱員供款：5%的公積金供款，或不多於《強制性公積金計劃條例》所訂上限的強積金供款(視乎何者適用而定)。",
            certify3:
                "按以下規定獲得公積金僱主供款：須符合現行有關資助學校人員退休福利撥款安排的教育局通告列明，按每名僱員在認可計劃的條件下無間斷供款的年資，以及按較高公積金僱主供款額的條件而計算。",
            certify4:
                "本人明白，補助只會提供予學校支付藉行政津貼／修訂行政津貼聘用的人員的公積金／強積金供款，以及教育局會根據經審核的帳目，發還公積金僱主供款津貼的實際不足之數，或收回未使用的津貼(視乎何者適用而定)。本表格所蒐集的資料用以計算公積金／強積金僱主供款暫定全年數額及其他相關事宜，並可能會向其他政府部門／機構披露，以供核數／統計之用。 ",
        },
        detail: "公積金／強積金僱主供款暫定全年數額詳情",
        totalSchoolYear: "學年總計",
        totalLastSchoolYear: "上學年總計",
        certify: "聲明",
        tooltip:
            "公積金／強積金補助不適用於藉資助小學的「供增聘文書助理的行政津貼」聘用的人員",
        conditions: "本人已閱讀、明白及同意上述條款及細則。",
        schoolType: "請選擇學校類別：",
        schoolName: "學校名稱",
        schoolCode: "學校代碼",
        schoolYear: "學年",
        grantType: "適用於學校的津貼",
        rank: "職級",
        numStaff: "人員數目",
        provisionalAnnSal: "學年全年薪金暫定總額",
        provisionalAnnEmpCon: "公積金／強積金僱主供款暫定全年數額",
        totalNumStaff: "學年總計(人員數目)",
        totalNumStaff1: "人員數目",
        totalProvisionalAnnSal: "學年總計(學年全年薪金暫定總額)",
        totalProvisionalAnnSal1: "學年全年薪金暫定總額",
        totalProvisionalAnnEmpCon:
            "學年總計(公積金／強積金僱主供款暫定全年數額)",
        totalProvisionalAnnEmpCon1: "公積金／強積金僱主供款暫定全年數額",
        numStaffLastYr: "上學年總計(人員數目)",
        provisionalAnnSalLastYr: "上學年總計(學年全年薪金暫定總額)",
        provisionalAnnEmpConLastYr:
            "上學年總計(公積金／強積金僱主供款暫定全年數額)",
        schoolHead: "校長",
        supervisor: "校監",
        schoolHeadOrSupervisor: "校監／校長",
        schoolHeadName: "校長姓名",
        supervisorName: "校監姓名",
        schoolHeadOrSupervisorName: "校監／校長姓名",
        name: "姓名",
        date: "日期",
        contactPerson: "聯絡人",
        tel: "電話",
    },
    formContent: {
        schoolTypeOption: {
            primarySchool: "資助小學",
            secondarySchool: "資助中學",
            specialSchool: "資助特殊學校",
        },
        grantTypeOption: {
            administrationGrant: "行政津貼",
            revisedAdministrationGrant: "修訂行政津貼 ",
        },
        schoolHeadOption: {
            schoolHead: "校長",
            supervisor: "校監",
        },
    },
    errorMsg: {
        telMax: "電話號碼必須為最多12位數",
    },
};
export default Form074TC;
